import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import pluralize from "pluralize";
import { memo, useMemo } from "react";
export const JumpToDropdown = /*#__PURE__*/ memo((param)=>{
    let { chapters, seekToChapter, activeChapterIndex } = param;
    const jumpToOptions = useMemo(()=>{
        return chapters.map((chapter, index)=>({
                id: "jump-to-chapter-".concat(index),
                label: /*#__PURE__*/ _jsxs("div", {
                    className: "whitespace-normal break-words",
                    children: [
                        index + 1,
                        ". ",
                        chapter.title
                    ]
                }),
                type: "item",
                onSelect: ()=>seekToChapter(chapter),
                active: index === activeChapterIndex
            }));
    }, [
        chapters,
        seekToChapter,
        activeChapterIndex
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            size: "small",
            color: "grey",
            suffix: /*#__PURE__*/ _jsx(TriangleDown, {
                className: "size-3"
            }),
            children: "".concat(chapters.length, " ").concat(pluralize("Chapter", chapters.length))
        }),
        className: "w-64",
        children: renderDropdownItems({
            options: jumpToOptions
        })
    });
});
JumpToDropdown.displayName = "JumpToDropdown";
